import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import clsx from 'clsx'
import { ICONS } from '@Const/common'
import React from 'react'

const PublicSearchNavLink = () => (
    <NavLink
        to={Navigation.search.root()}
        className={({ isActive }) => clsx('icon-button', isActive && 'active')}
        title="Public Search"
    >
        <img src={ICONS.workSearch} alt="search" />
    </NavLink>
)

export default PublicSearchNavLink
